const React = require('react')
const { useState } = require('react')
const { Button } = require('reactstrap')
const { useNetworkConfig } = require('@contexts')

require('@styles/pages/address/contract.address.css')

const ConnectMetamask = props => {
    const { network } = useNetworkConfig()

    const { account, setAccount } = props
    const [isConnecting, setIsConnecting] = useState(false)

    const switchOrAddNetwork = async () => {
        try {
            const chainIdHex = `0x${parseInt(network.data.chainId).toString(16)}`

            try {
                // Try to switch network
                await window.ethereum.request({
                    method: 'wallet_switchEthereumChain',
                    params: [{ chainId: chainIdHex }]
                })
            } catch (switchError) {
                // This error code indicates the chain is not added to MetaMask
                if (switchError.code === 4902) {
                    try {
                        await window.ethereum.request({
                            method: 'wallet_addEthereumChain',
                            params: [
                                {
                                    chainId: chainIdHex,
                                    chainName: network.name,
                                    nativeCurrency: {
                                        name: network.token,
                                        symbol: network.token,
                                        decimals: 18
                                    },
                                    rpcUrls: [network.data.endpoint],
                                    blockExplorerUrls: ['https://explorer.vbchain.vn']
                                }
                            ]
                        })
                    } catch (addError) {
                        console.error('Error adding network:', addError)
                        throw addError
                    }
                } else {
                    throw switchError
                }
            }
        } catch (error) {
            console.error('Network error:', error)
            throw error
        }
    }

    const connectToMetaMask = async () => {
        try {
            if (!window.ethereum) {
                alert('Please install MetaMask!')
                return
            }

            // Disconnect if already connected
            if (account) {
                setAccount(null)
                return
            }

            setIsConnecting(true)

            // First handle network configuration
            await switchOrAddNetwork()

            // Then request account access
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' })
            setAccount(accounts[0])
        } catch (error) {
            console.error('MetaMask connection error:', error)
        } finally {
            setIsConnecting(false)
        }
    }

    return (
        <Button
            style={{
                background: 'rgba(210, 210, 210, 0.1)',
                whiteSpace: 'nowrap',
                padding: '4px 10px',
                minHeight: '30px',
                fontSize: '12px',
                fontWeight: 'bold',
                border: '0px',
                overflow: 'visible',
                display: 'flex',
                alignItems: 'center'
            }}
            onClick={connectToMetaMask}
            disabled={isConnecting}
        >
            <span
                style={{
                    width: '8px',
                    height: '8px',
                    borderRadius: '50%',
                    backgroundColor: account
                        ? 'var(--success-color)'
                        : isConnecting
                        ? 'var(--warning-color)'
                        : 'var(--fail-color)'
                }}
            />
            &nbsp;
            <span>
                {account
                    ? `Connected: ${account.substring(0, 6)}...${account.substring(38)}`
                    : isConnecting
                    ? 'Connecting...'
                    : 'Connect to Web3'}
            </span>
        </Button>
    )
}

module.exports = { ConnectMetamask }
